import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import './Portfolio.css';

const Portfolio = () => {
  const { isFrench } = useLanguage();

  const projects = [
    {
      title: "The Gift",
      category: "Mobile · Startup",
      description: "App de recommandation de cadeaux (TheGift SAS) — App Store & Google Play.",
      stack: ["Kotlin Multiplatform", "Firebase", "React", "CI/CD"],
      highlights: ["Co-fondatrice & CTO", "Algorithme de recommandation", "Publication iOS / Android"],
      id: "the-gift",
      featured: true
    },
    {
      title: "MadBeauty",
      category: "Mobile",
      description: "Réservation de prestations beauté en Flutter / Supabase.",
      stack: ["Flutter", "Supabase", "Stripe", "FCM"],
      highlights: ["Provisioning iOS", "Abonnements Stripe", "Notifications push"],
      id: "madbeauty",
      featured: true
    },
    {
      title: "JunaPay",
      category: "Fintech · Mobile",
      description: "Plateforme de paiement mobile pour l'Afrique francophone.",
      stack: ["Spring Boot", "Flutter", "Angular", "FCM"],
      highlights: ["Dashboard admin Angular", "API REST sécurisée", "Notifications FCM"],
      id: "junapay",
      featured: true
    },
    {
      title: "ORCA",
      category: "Outil interne",
      description: "Automatisation de tests d'API — stage NOUPS Consulting.",
      stack: ["Angular", "Java", "REST API"],
      highlights: ["Scénarios de tests automatisés", "Front Angular & back Java"],
      id: "orca",
      featured: false
    },
    {
      title: "Gestion de Parc Informatique",
      category: "Desktop & Web",
      description: "Gestion de parc avec ASP.NET Core, Blazor Server et WPF.",
      stack: ["ASP.NET Core", "Blazor", "WPF", "SQL Server"],
      highlights: ["API REST Swagger", "Service Windows de monitoring"],
      id: "parc-informatique",
      featured: false
    },
    {
      title: "Café Shop",
      category: "Full-Stack",
      description: "Gestion de café avec Spring Boot et React.",
      stack: ["Spring Boot", "React", "MySQL", "Docker"],
      highlights: ["Gestion stocks & commandes", "API JWT sécurisée"],
      id: "cafe-shop",
      featured: false
    },
    {
      title: "E-commerce Web",
      category: "Web",
      description: "Site e-commerce PHP avec tests Selenium.",
      stack: ["PHP", "MySQL", "Selenium", "Bootstrap"],
      highlights: ["Agile Scrum", "Tests automatisés"],
      id: "ecommerce",
      featured: false
    }
  ];

  const featured = projects.filter((p) => p.featured);
  const others = projects.filter((p) => !p.featured);

  const renderCard = (project) => (
    <Link key={project.id} to={`/project/${project.id}`} className={`portfolio-item${project.featured ? ' portfolio-item-featured' : ''}`}>
        <div className="portfolio-item-header">
          <div>
            <span className="portfolio-item-category">{project.category}</span>
            <h3>{project.title}</h3>
          </div>
          <ArrowRight size={20} className="portfolio-item-arrow" />
        </div>

        <p className="portfolio-item-desc">{project.description}</p>

        <ul className="portfolio-item-highlights">
          {project.highlights.map((item, idx) => (
            <li key={idx}>
              <CheckCircle2 size={16} />
              <span>{item}</span>
            </li>
          ))}
        </ul>

        <div className="portfolio-item-tech">
          {project.stack.map((tech) => (
            <span key={tech} className="tech-pill">{tech}</span>
          ))}
        </div>
    </Link>
  );

  return (
    <section className="portfolio" id="portfolio">
      <div className="portfolio-container">
        <div className="section-intro">
          <h2 className="heading">
            {isFrench ? <>Mes <span>Projets</span></> : <>My <span>Projects</span></>}
          </h2>
          <p className="section-subtitle">
            {isFrench
              ? 'Produits livrés, applications mobiles et projets techniques.'
              : 'Shipped products, mobile apps and technical projects.'}
          </p>
        </div>

        <div className="portfolio-section-label">
          {isFrench ? 'Projets phares' : 'Featured projects'}
        </div>
        <div className="portfolio-list">
          {featured.map((project) => renderCard(project))}
        </div>

        <div className="portfolio-section-label">
          {isFrench ? 'Autres projets' : 'Other projects'}
        </div>
        <div className="portfolio-list portfolio-list-compact">
          {others.map((project) => renderCard(project))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
